import { InnoveraIcon } from "@libs/zapi-ui/assets";
import { AppButton, Typography } from "@libs/zapi-ui/custom";

type TOutlineEmptyProps = {
  onGenerate: () => void;
};

export function OutlineEmpty({ onGenerate }: TOutlineEmptyProps) {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <Typography variant="heading6" className="mb-3">
        Turn Your Model into a Presentation
      </Typography>
      <Typography variant="body2" color="zinc600" className="mb-6 text-center">
        Generate a text-based presentation outline from your <br /> model, then convert it into a fully designed
        presentation <br /> with visuals, charts, and layouts.
      </Typography>
      <AppButton
        onClick={onGenerate}
        className="[&_svg>path]:fill-white"
        startAdornment={<InnoveraIcon width={16} height={16} />}
        data-testid="presentation-generate-outline"
      >
        <Typography variant="label2">Generate Presentation Outline</Typography>
      </AppButton>
    </div>
  );
}
